import AsyncState from '../AsyncState/AsyncState';
import SeatMap, { type SeatMapItem } from '../SeatMap/SeatMap';

import styles from './seatMapPanel.module.css';

export interface SeatMapPanelProps<T extends SeatMapItem = SeatMapItem> {
  title: string;
  seats: readonly T[];
  selectedIds: readonly string[];
  emptyMessage: string;
  description?: string;
  seatLabel: (seat: T) => string;
  onToggle: (seat: T) => void;
  error?: boolean;
  loadFailedTitle?: string;
  retryLabel?: string;
  onRetry?: () => void;
}

const SeatMapPanel = <T extends SeatMapItem>({
  title,
  seats,
  selectedIds,
  emptyMessage,
  description,
  seatLabel,
  onToggle,
  error = false,
  loadFailedTitle,
  retryLabel,
  onRetry
}: SeatMapPanelProps<T>) => {
  if (error) {
    return (
      <AsyncState
        status="error"
        title={loadFailedTitle}
        actionLabel={retryLabel}
        onAction={onRetry}
      />
    );
  }

  if (seats.length === 0) {
    return <AsyncState status="empty" message={emptyMessage} />;
  }

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>{title}</h2>
      <SeatMap
        seats={seats}
        selectedIds={selectedIds}
        seatLabel={seatLabel}
        onToggle={onToggle}
      />
      {description && <p className={styles.description}>{description}</p>}
    </section>
  );
};

export default SeatMapPanel;
